/**
 * Centros que pueden ver el botón "Calcular nota" en la ficha del ciclo.
 */
const CENTROS_CON_BOTON_NOTA = [
  'SUPERADMIN',
  'CNTEC Girona',
  'CEDESCA',
  'CNTEC Sevilla',
  'SECRETARÍA',
];

export default CENTROS_CON_BOTON_NOTA;
